import { Checkout, FormValues } from '@types';

interface ErrorInfo {
  token?: string;
  terminalId?: string;
  campaignId?: number;
  organization?: string;
  lastSessionStatus?: string;
  checkoutData?: Partial<FormValues>;
  checkout?: Checkout;
  code?: string;
  message?: string;
  stripeError?: string;
  errorObject?: any;
}

const composeErrorMessage = (info: ErrorInfo) => {
  return `
    Error from riseact-checkout
    Checkout token: ${info.token}
    Terminal ID: ${info.terminalId}
    Campaign ID: ${info.campaignId}
    Organization: ${info.organization}
    Last session status: ${info.lastSessionStatus}
    Checkout data: ${JSON.stringify(info.checkoutData)}
    Checkout: ${JSON.stringify(info.checkout)}
    Error code: ${info.code}
    Error message: ${info.message}
    Stripe error: ${info.stripeError}
    Error object: ${JSON.stringify(info.errorObject)}
    `;
};

export default composeErrorMessage;
